import React from 'react';
import { connect } from 'react-redux';

const STATUSES = [
  { key: 'processing', label: 'Processing', icon: 'fas fa-cog',          color: '#dc2626' },
  { key: 'confirmed',  label: 'Confirmed',  icon: 'fas fa-check-circle', color: '#059669' },
];

const OrderStatusBreakdown = ({ latestOrders }: any) => {
  const counts = latestOrders.orders.reduce((acc: Record<string, number>, order: any) => {
    const s = (order.orderStatus ?? '').toLowerCase();
    acc[s] = (acc[s] ?? 0) + 1;
    return acc;
  }, {});

  const total = latestOrders.orders.length;

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Order Breakdown</p>
        {total > 0 && <span className="admin-card-subtitle">{total} today</span>}
      </div>
      <div className="admin-card-body">
        {total === 0 ? (
          <div className="admin-empty-state">
            <i className="fas fa-shopping-bag" />
            <p>No orders today</p>
          </div>
        ) : (
          <div className="order-breakdown-list">
            {STATUSES.map(({ key, label, icon, color }) => {
              const count = counts[key] ?? 0;
              const pct = total > 0 ? Math.round((count / total) * 100) : 0;
              return (
                <div key={key} className="order-breakdown-row">
                  <div className="order-breakdown-left">
                    <i className={icon} style={{ color, width: 16, textAlign: 'center' }} />
                    <span className="order-breakdown-label">{label}</span>
                  </div>
                  <div className="order-breakdown-bar-wrap">
                    <div
                      className="order-breakdown-bar"
                      style={{ width: `${pct}%`, background: color }}
                    />
                  </div>
                  <span className="order-breakdown-count">{count}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  latestOrders: state.latestOrders,
});

export default connect(mapStateToProps)(OrderStatusBreakdown);
